import {
    SkyNetTableField,
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import injectFieldsToTabs from 'app/shared-components/SkyNetTable/hooks/utils/injectFieldsToTabs'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'

import {
    AddressCategory,
    LocationType,
} from 'app/enums/label.enums'

export const getTabUrl = (name: LocationType) => {
    const tabUrls = {
        [LocationType.ADDRESS]: 'address',
        [LocationType.AIRPORT]: 'airport',
        [LocationType.SEAPORT]: 'seaport',
    }

    return tabUrls[name] || CommonRoutes.All
}

const fields: SkyNetTableField[] = [
    {
        name: 'locationName',
        reduced: true,
    },
    {
        name: 'addressLine1',
        filterType: FilterType.Array,
    },
    {
        name: 'zip',
        filterType: FilterType.Array,
    },
    {
        name: 'city',
        reduced: true,
    },
    {
        name: 'countryName',
        filterField: 'countryName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'country',
    },
    {
        name: 'isMainAddress',
        componentName: 'ChipCheckMark',
    },
    {
        name: 'companyName',
        filterField: 'companyName',
        filterType: FilterType.Array,
        labelKey: 'company',
    },
    {
        name: 'addressCategory',
        componentName: 'EnumList',
        allowedValuesEnum: AddressCategory,
    },
]

const config: SkyNetTableConfig = {
    name: 'LocationTable',
    tabs: injectFieldsToTabs([
        {
            name: 'All Locations',
            url: CommonRoutes.All,
        },
        {
            name: 'Addresses',
            url: getTabUrl(LocationType.ADDRESS),
            includeFilters: {
                locationType: [LocationType.ADDRESS],
            },
        },
    ], fields),
}

export default config
